<template>
  <div>
    <div v-for="(accommodation, index) in accommodation_list" :key="_uid+'accommodation'+index">
      <vb-tabs v-if="accommodation.servizi.length">
        <b-tab
          v-for="(service, s_index) in accommodation.servizi"
          :key="_uid+'service'+s_index"
          :title="service.titolo_servizi_struttura | lowercase"
        >
          <span v-html="service.descrizione_servizi_struttura"></span>
        </b-tab>
      </vb-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accommodations',

  props: {
    // prop per uso dinamico in detail-price (pattern detail_blocks)
    statics_detail: Object,
  },

  computed: {
    accommodation_list() {
      if (this.statics_detail) {
        const first = Object.values(this.statics_detail)[0]
        if (first && first.schedaProdotto) {
          return first.schedaProdotto.sistemazioni || []
        }
      }
      return []
    },
  },
}
</script>

<style lang="scss">
  .information .vb-tabs {
    margin-top: $grid-gutter-width*2;
  }
</style>
